import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-67ff0cc7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "all-container"
};
const _hoisted_2 = {
  class: "nav-bar"
};
import { computed, onMounted, ref, onBeforeUnmount } from 'vue';
import SideBar from './Sidebar/index.vue';
import AppMain from './AppMain/index.vue';
import NavBar from './Navbar/index.vue';
import BreadCrumb from './BreadCrumb/index.vue';
// import { myClearInterval } from '@/utils/publicMethod';
// import { UserApi } from '@/api/user';
// import Storage from '@/utils/storage';
// import { useRouter } from 'vue-router';
// import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const open = ref(true);
    // const timer = ref();
    // const Router = useRouter();
    const sideBarOpen = computed(() => open.value);
    onMounted(() => {
      if (document.body.getBoundingClientRect().width - 1 < 1320) {
        open.value = false;
      }
      // const access_token = Storage.getItem('access_token');
      // const refresh_token = Storage.getItem('refresh_token');
      window.addEventListener('resize', resizeHandler);
      // timer.value = mysetInterval(() => {
      //   UserApi.tokenCheck({ access_token, refresh_token }).then((res: any) => {
      //     if (res.code === 1) {
      //       Storage.removeItem('Bearer');
      //       Router.push({ path: '/user/login' });
      //       ElMessage.error('您的账号已在其他设备登录，若不是本人操作，请及时修改密码');
      //     }
      //   });
      // }, 3000);
    });

    onBeforeUnmount(() => {
      // myClearInterval(timer.value);
      window.removeEventListener('resize', resizeHandler);
    });
    function resizeHandler() {
      const rect = document.body.getBoundingClientRect();
      if (rect.width - 1 < 1320) {
        open.value = false;
      } else {
        open.value = true;
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(sideBarOpen) ? (_openBlock(), _createBlock(SideBar, {
        key: 0,
        class: "aside-container"
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createVNode(NavBar)]), _createElementVNode("div", {
        class: _normalizeClass(["main-container", {
          'without-side': !_unref(sideBarOpen)
        }])
      }, [_createVNode(BreadCrumb), _createVNode(AppMain)], 2)]);
    };
  }
});